import React, { useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Button from 'components/Button'
import Table from 'components/Table.old'
import TimeAgo from 'components/TimeAgo'

import ModalContext from 'containers/ModalManager/ModalContext'

import DeleteTokenModal from '../DeleteTokenModal'

const MAX_CODE_CHAR_TO_SHOW = 7

const KeyTableCell = styled(Table.Cell)`
  color: ${({ theme }) => theme.colors.black};
`

const DeleteButtonTableCell = styled(Table.Cell).attrs({ shrink: true })`
  text-align: right;
`

const DeleteButton = styled(Button).attrs({
  small: true,
  children: 'Delete',
})`
  color: ${({ theme }) => theme.colors.red};
`

/**
 * TokensTable
 *
 * This component presents the user tokens in a table.
 * It's also responsible for calling the {@link DeleteTokenModal} if the user
 * chooses to delete a token.
 *
 * @param {Object} props - Component props.
 * @param {string} props.items - The list of the user personal token
 *
 */
const TokensTable = ({ items }) => {
  const { showModal } = useContext(ModalContext)

  const handleTokenMap = useCallback(
    ({ code, createdAt, shortId }) => {
      /* This prevents a newly created token to show all digits */
      const token = code.substring(code.length - MAX_CODE_CHAR_TO_SHOW)

      return (
        <Table.Row key={code}>
          <KeyTableCell>
            ···
            {token}
          </KeyTableCell>
          <Table.Cell>
            <TimeAgo date={createdAt} />
          </Table.Cell>
          <DeleteButtonTableCell>
            <DeleteButton
              token={code}
              onClick={() => {
                showModal(DeleteTokenModal, { token, shortId })
              }}
            />
          </DeleteButtonTableCell>
        </Table.Row>
      )
    },
    [showModal]
  )

  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Key</Table.HeaderCell>
          <Table.HeaderCell>Created</Table.HeaderCell>
          <Table.HeaderCell>
            {/* Column for the Delete Button, no label on header */}
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{items.map(handleTokenMap)}</Table.Body>
    </Table>
  )
}

TokensTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      shortId: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default TokensTable
